// extracted by mini-css-extract-plugin
module.exports = {"HeroWrap":"CourseHero_HeroWrap__Mh7Pw","HeroTitle":"CourseHero_HeroTitle__opKla","HeroSubTitle":"CourseHero_HeroSubTitle__Foad4"};